const routes = [
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('@/views/Usuario/Usuarios')
  }, {
    path: '/usuarios/nuevo',
    name: 'usuarios.nuevo',
    component: () => import('@/views/Usuario/Guardar')
  }, {
    path: '/usuarios/editar/:id',
    name: 'usuarios.editar',
    component: () => import('@/views/Usuario/Guardar')
  }, {
    path: '/usuarios/perfil',
    name: 'perfil',
    meta: { withoutPermissions: true },
    component: () => import('@/views/Usuario/Perfil')
  },
  {
    path: '/usuarios/equipo',
    name: 'usuarios.equipo',   
    component: () => import('@/views/Usuario/UsuariosEquipo')
  }
]

export default routes
